import React from 'react'
import Payment from './payment'
import { IPaymentProps } from './paymentinterface'

const paymentcontainer = (props: IPaymentProps) => {

  return (
      <Payment baseRef={props?.baseRef} isNextClick={props?.isNextClick} getDivRef={props?.getDivRef} updateStepperDetails={props.updateStepperDetails} itemSummaryDetails={props.itemSummaryDetails} cartsDetails={props.cartsDetails} />
  )
}

export default paymentcontainer